import { styled, TabPanel as JoyTabPanel } from '@mui/joy';

import { LEFT_MENU_WIDTH } from 'theme/constants';

interface IProps {
  fullWidth?: boolean;
}

const propsToSkip: PropertyKey[] = ['fullWidth'];
const shouldForwardProp = (propName: PropertyKey) => !propsToSkip.includes(propName);

export const TabPanel = styled(JoyTabPanel, { shouldForwardProp })<IProps>(({ fullWidth }) => ({
  height: '100%',
  ...(fullWidth && {
    width: `calc(100vw - ${LEFT_MENU_WIDTH}px - 2 * 24px)`,
  }),
}));
